<template>
  <div>
    <template v-if="isMobile">
      <el-dialog
        class="save-shipping-address-dialog"
        :title="title"
        :visible="shippingAddressDialog"
        :before-close="beforeClose"
        close-on-press-escape
        append-to-body
        custom-class="col-xs-12"
        top="30px"
        width="100%"
        @open="opening"
      >
        <el-form ref="form" :model="addressForm" label-width="7rem" label-position="top" :rules="addressFormRules">

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.label')" prop="label">
                <el-input v-model.trim="addressForm.label" :placeholder="$t('shipping_address.label_placeholder')" clearable />
              </el-form-item>
            </div>
          </div>

          <div class="row mb-10">
            <div class="col">
              {{ $t('shipping_address.reference_name') }}:
              <el-button-group class="ml-2">
                <el-button size="mini" @click="setLabelValue($t('shipping_address.my_home'))">
                  {{ $t('shipping_address.my_home') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.parents_home'))">
                  {{ $t('shipping_address.parents_home') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.apartment'))">
                  {{ $t('shipping_address.apartment') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.school'))">
                  {{ $t('shipping_address.school') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.company'))">
                  {{ $t('shipping_address.company') }}
                </el-button>
              </el-button-group>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.consignee')" prop="consignee" class="mb-10">
                <el-input v-model.trim="addressForm.consignee" :placeholder="$t('shipping_address.consignee_placeholder')" clearable />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.mobile')" prop="mobile" class="mb-10">
                <phone-input ref="mobilePhoneInput" v-model="addressForm.mobile" :placeholder="$t('shipping_address.mobile_placeholder')" />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.district')" prop="selectedDistricts" class="mb-10">
                <el-cascader
                  clearable
                  expand-trigger="hover"
                  :options="districts"
                  v-model="addressForm.selectedDistricts"
                  :placeholder="$t('shipping_address.select_district')"
                  :props="{ value: 'id', label: 'language_name', children: 'zones' }"
                />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.line1')" prop="line1" class="mb-10">
                <el-input v-model="addressForm.line1" :placeholder="$t('shipping_address.address_placeholder')" />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.line2')" class="mb-10">
                <el-input v-model="addressForm.line2" :placeholder="$t('shipping_address.address_placeholder')" />
              </el-form-item>
            </div>
          </div>

        </el-form>

        <div slot="footer" class="el-dialog__footer col-11 p-0">
          <el-button type="primary" @click="save()">{{ $t('app.save') }}</el-button>
          <el-button type="danger"  @click="deleteAddress(editId)">{{ $t('app.delete') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <template v-else>
      <el-dialog
        class="save-shipping-address-dialog"
        :title="title"
        :visible="shippingAddressDialog"
        :before-close="beforeClose"
        close-on-press-escape
        append-to-body
        custom-class="col-xs-12"
        top="50px"
        @open="opening"
      >
        <el-form class="pl-10 pr-10" ref="form" :model="addressForm" label-width="7rem" label-position="top" :rules="addressFormRules">

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.label')" prop="label">
                <el-input v-model.trim="addressForm.label" :placeholder="$t('shipping_address.label_placeholder')" clearable />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              {{ $t('shipping_address.reference_name') }}:
              <el-button-group class="ml-2">
                <el-button size="mini" @click="setLabelValue($t('shipping_address.my_home'))">
                  {{ $t('shipping_address.my_home') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.parents_home'))">
                  {{ $t('shipping_address.parents_home') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.apartment'))">
                  {{ $t('shipping_address.apartment') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.school'))">
                  {{ $t('shipping_address.school') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.company'))">
                  {{ $t('shipping_address.company') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.express_box'))">
                  {{ $t('shipping_address.express_box') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.warehouse'))">
                  {{ $t('shipping_address.warehouse') }}
                </el-button>
                <el-button size="mini" @click="setLabelValue($t('shipping_address.hostel'))">
                  {{ $t('shipping_address.hostel') }}
                </el-button>
              </el-button-group>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.consignee')" prop="consignee">
                <el-input v-model.trim="addressForm.consignee" :placeholder="$t('shipping_address.consignee_placeholder')" clearable />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.mobile')" prop="mobile">
                <phone-input ref="mobilePhoneInput" v-model="addressForm.mobile" :placeholder="$t('shipping_address.mobile_placeholder')" />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.district')" prop="selectedDistricts">
                <el-cascader
                  clearable
                  expand-trigger="hover"
                  :options="districts"
                  v-model="addressForm.selectedDistricts"
                  :placeholder="$t('shipping_address.select_district')"
                  :props="{ value: 'id', label: 'language_name', children: 'zones' }"></el-cascader>
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.line1')" prop="line1">
                <el-input v-model="addressForm.line1" :placeholder="$t('shipping_address.address_placeholder')" />
              </el-form-item>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <el-form-item :label="$t('shipping_address.line2')" prop="line2">
                <el-input v-model="addressForm.line2" :placeholder="$t('shipping_address.address_placeholder')" />
              </el-form-item>
            </div>
          </div>

        </el-form>

        <div slot="footer" class="el-dialog__footer col-11 p-0">
          <el-button type="primary" @click="save()">{{ $t('app.save') }}</el-button>
          <!--<el-button type="danger"  @click="deleteAddress(editId)">{{ $t('app.delete') }}</el-button>-->
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mapState, mapGetters } from 'vuex';
  import PhoneInput from '../../components/PhoneInput.vue';
  import { SET_SHIPPING_ADDRESS_DIALOG } from '../../store/mutation-types';
  import { showErrorMessage, phoneValidate } from '../../plugins/helpers';

  export default {
    name: 'SaveShippingAddressDialog',
    props: {
      editId: {
        type: Number,
        request: true,
      },
      handleOpen: Function,
    },
    data() {
      return {
        title: '',
        isSaved: false,
        addressForm: {
          label: '',
          consignee: '',
          zipcode: '',
          email: '',
          company: '',
          mobile: '',
          phone: '',
          line1: '',
          line2: '',
          additional_information: '',
          selectedDistricts: [],
        },
        addressFormRules: {
          label: { required: true, message: this.$t('shipping_address.rules.label_reduired'), trigger: 'blur' },
          consignee: { required: true, message: this.$t('shipping_address.rules.consignee_reduired'), trigger: 'blur' },
          email: [
            { required: true, message: this.$t('shipping_address.rules.email_reduired'), trigger: 'blur' },
            { type: 'email', message: this.$t('shipping_address.rules.email'), trigger: 'blur' },
          ],
          mobile: [
            { required: true, message: this.$t('shipping_address.rules.mobile_reduired'), trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (phoneValidate(value, this.$refs.mobilePhoneInput.getCountryCode(), 'mobile')) {
                  callback();
                } else {
                  callback(new Error(this.$t('validate.mobile')));
                }
              },
              trigger: 'blur',
            },
          ],
          phone: {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (phoneValidate(value, this.$revs.fixedLinePhoneInput.getCountryCode(), 'fixed_line')) {
                callback();
              } else {
                callback(new Error(this.$t('validate.mobile')));
              }
            },
            trigger: 'blur',
          },
          selectedDistricts: {
            required: true,
            type: 'array',
            length: 2,
            message: this.$t('shipping_address.rules.selectedDistricts_reduired'),
            trigger: 'blur',
          },
          line1: { required: true, message: this.$t('shipping_address.rules.line1_required'), trigger: 'blur' },
          line2: { required: false, message: this.$t('shipping_address.rules.line1_required'), trigger: 'blur' },
        },
      };
    },
    mounted() {
      this.$store.dispatch('fetchDistricts');
      this.opening();
    },
    computed: {
      ...mapState({
        identity: state => state.user.identity,
        districts: state => state.user.districts,
      }),
      ...mapGetters([
        'isMobile',
      ]),
      shippingAddressDialog: {
        get() {
          return this.$store.state.user.shippingAddressDialog;
        },
        set(val) {
          this.$store.commit(SET_SHIPPING_ADDRESS_DIALOG, val);
        },
      },
    },
    methods: {
      deleteAddress(id) {
        this.$confirm(this.$t('shipping_address.confirm_delete'), this.$t('app.tips'), {
          confirmButtonText: this.$t('app.confirm'),
          cancelButtonText: this.$t('app.cancel'),
          type: 'warning',
        }).then(() => {
          this.$store.dispatch('deleteShippingAddress', id).then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('shipping_address.deleted'),
            });
            this.shippingAddressDialog = false;
          });
        }).catch((error) => {
          if (error.response) {
            this.$notify({
              type: 'danger',
              title: this.$t('app.delete_err'),
              message: error.response.data.message,
            });
          }
        });
      },
      opening() {
        this.isSaved = false;
        this.presetLabel = '';
        if (this.editId) {
          this.$api.shippingAddress.getById(this.editId).then((response) => {
            const { data } = response.data;
            this.title = `${this.$t('shipping_address.edit_address')} ${data.label}`;
            this.addressForm.label = data.label;
            this.addressForm.consignee = data.consignee;
            this.addressForm.email = data.email;
            this.addressForm.company = data.company;
            this.addressForm.zipcode = data.zipcode;
            this.addressForm.address = data.address;
            this.addressForm.phone = data.phone;
            this.addressForm.mobile = data.mobile;
            this.addressForm.line1 = data.line1;
            this.addressForm.line2 = data.line2;
            // eslint-disable-next-line
            this.addressForm.selectedDistricts = [data.country_id, data.zone_id];
            this.$refs.mobilePhoneInput.setValue(data.mobile);
          });
        } else {
          this.title = this.$t('shipping_address.add_address');
          this.addressForm.label = '';
          this.addressForm.consignee = '';
          this.addressForm.email = '';
          this.addressForm.company = '';
          this.addressForm.zipcode = '';
          this.addressForm.address = '';
          this.addressForm.phone = '';
          this.addressForm.mobile = '';
          this.addressForm.line1 = '';
          this.addressForm.line2 = '';
          // eslint-disable-next-line
          this.addressForm.selectedDistricts = [];
        }
      },
      setLabelValue(val) {
        this.addressForm.label = val;
      },
      beforeClose(done) {
        if (this.isSaved) {
          this.shippingAddressDialog = false;
          done();
        } else {
          this.$confirm(this.$t('shipping_address.confirm_close_dialog'), {
            customClass: this.isMobile ? 'mobile' : '',
          }).then(() => {
            this.shippingAddressDialog = false;
            done();
          }).catch(() => {});
        }
      },

      save() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            /* eslint-disable prefer-destructuring */
            const params = _.cloneDeep(this.addressForm);
            params.country_id = this.addressForm.selectedDistricts[0];
            params.zone_id = this.addressForm.selectedDistricts[1];

            if (this.editId) {
              this.$store.dispatch('editShippingAddress', { id: this.editId, params })
                .then(this.showSuccess)
                .catch(showErrorMessage);
            } else {
              this.$store.dispatch('addShippingAddress', params)
                .then(this.showSuccess)
                .catch(showErrorMessage);
            }
          } else {
            this.$message({
              message: this.$t('shipping_address.required_field_no_compltet'),
              center: true,
              type: 'error',
            });
          }
        });
      },
      showSuccess() {
        this.$notify({
          title: this.$t('shipping_address.address_has_been_save'),
          type: 'success',
        });
        this.shippingAddressDialog = false;
      },
    },
    components: {
      PhoneInput,
    },
  };
</script>

<style lang="scss">
  .el-message-box {
    &.mobile {
      width: 80%;
    }
  }
  .save-shipping-address-dialog {
    .el-form-item {
      .el-form-item__label {
        padding: 0;
        margin: 0;
      }
    }
    @media (min-width: 768px) {
        width: 100% !important;
        padding: 0 5%;
      .el-dialog__body {
        padding-top: 0px;
        max-height: 500px;
        overflow: hidden;
        overflow-y: scroll;
      }
      .el-dialog__footer {
        padding: 10px;
      }
    }
    .el-cascader {
      width: 100%;
    }
    .el-select .el-input {
      width: 130px;
    }
  }
</style>
